import {CSSProperties} from "react";
import {Vector2} from "@utility/vector2";

export const SCREEN_SIZE = window.innerWidth > 600 ? "large" :
    window.innerHeight < 900 ? "small": "medium";
export const TILE_BORDER = {small: 3, medium: 4, large: 4}[SCREEN_SIZE];
const TILE_EDGE = {small: 48, medium: 64, large: 64}[SCREEN_SIZE];
const LETTER_FONT_SIZE = {small: 36, medium: 46, large: 46}[SCREEN_SIZE];
const BONUS_FONT_SIZE = {small: 20, medium: 34, large: 34}[SCREEN_SIZE];
export const TILE_SIZE = new Vector2(TILE_EDGE, TILE_EDGE);
const LETTER_BORDER = new Vector2(TILE_BORDER, TILE_BORDER);
export const LETTER_SIZE = TILE_SIZE.minus(LETTER_BORDER);

// ── Cartographic palette ───────────────────────────────────────────────────────
export const COLOURS = {
    parchment:      "#f5f0e8",
    parchmentDark:  "#e8dcc8",
    ink:            "#1a1a1a",
    forestGreen:    "#2d5a1b",
    forestLight:    "#4a7c35",
    darkWood:       "#3d2b1f",
    agedBorder:     "#c8b89a",
    amber:          "#8b6914",
    amberLight:     "#c8960c",
    overlay:        "rgba(26, 16, 8, 0.6)"
};

export const LETTER_THEME: Record<string, CSSProperties> = {
    bonus: {
        fontFamily: "monospace",
        fontSize: BONUS_FONT_SIZE,
        fontWeight: "bold",
        color: "white",
        userSelect: "none"
    },
    container: {
        borderRadius: TILE_BORDER,
        height: LETTER_SIZE.y,
        width: LETTER_SIZE.x,
        padding: 1
    },
    content: {
        flexGrow: 1,
        fontFamily: "monospace",
        fontSize: LETTER_FONT_SIZE,
        fontWeight: "normal",
        textAlign: "center",
        userSelect: "none"
    }
};

const text: CSSProperties = {
    fontFamily: "Georgia, 'Palatino Linotype', serif",
    fontWeight: "normal",
    userSelect: "none"
}

export const THEME: Record<string, CSSProperties> = {
    button: {
        backgroundColor: COLOURS.forestGreen,
        border: `1px solid ${COLOURS.amber}`,
        borderRadius: 6,
        boxShadow: "0 2px 4px rgba(0,0,0,0.35)",
        color: COLOURS.parchment,
        cursor: "pointer",
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        fontWeight: "bold",
        margin: 4,
        padding: "6px 14px",
        userSelect: "none",
        WebkitTextFillColor: COLOURS.parchment
    },
    buttons: {
        paddingTop: 12,
        alignItems: "center",
        display: "flex",
        justifyContent: "flex-end"
    },
    heading: {
        ...text,
        fontSize: "x-large",
        color: COLOURS.forestGreen
    },
    input: {
        backgroundColor: COLOURS.parchment,
        border: `1px solid ${COLOURS.agedBorder}`,
        borderRadius: 4,
        fontFamily: "Georgia, 'Palatino Linotype', serif",
        margin: 4,
        maxWidth: 200,
        padding: "4px 8px"
    },
    label: {
        flexGrow: 1,
        color: COLOURS.ink
    },
    labelledInput: {
        alignItems: "center",
        display: "flex",
        flexGrow: 1
    },
    text: {
        ...text,
        color: COLOURS.ink
    }
};
